var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9981158F-4884-4DB5-A5CD-9E643A472300") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.75,7.5 L9.75,7.5 C9.88807119,7.5 10,7.61192881 10,7.75 L10,8.91666667 C10,9.05473785 9.88807119,9.16666667 9.75,9.16666667 L2.75,9.16666667 C2.61192881,9.16666667 2.5,9.05473785 2.5,8.91666667 L2.5,7.75 C2.5,7.61192881 2.61192881,7.5 2.75,7.5 Z M0.833333333,1.66666667 C0.373096042,1.66666667 0,1.29357062 0,0.833333333 C0,0.373096042 0.373096042,0 0.833333333,0 C1.29357062,0 1.66666667,0.373096042 1.66666667,0.833333333 C1.66666667,1.29357062 1.29357062,1.66666667 0.833333333,1.66666667 Z M2.75,0 L13.0833333,0 C13.2214045,-2.53632657e-17 13.3333333,0.111928813 13.3333333,0.25 L13.3333333,1.41666667 C13.3333333,1.55473785 13.2214045,1.66666667 13.0833333,1.66666667 L2.75,1.66666667 C2.61192881,1.66666667 2.5,1.55473785 2.5,1.41666667 L2.5,0.25 C2.5,0.111928813 2.61192881,2.53632657e-17 2.75,0 Z M2.75,2.5 L9.75,2.5 C9.88807119,2.5 10,2.61192881 10,2.75 L10,3.91666667 C10,4.05473785 9.88807119,4.16666667 9.75,4.16666667 L2.75,4.16666667 C2.61192881,4.16666667 2.5,4.05473785 2.5,3.91666667 L2.5,2.75 C2.5,2.61192881 2.61192881,2.5 2.75,2.5 Z M0.833333333,6.66666667 C0.373096042,6.66666667 0,6.29357062 0,5.83333333 C0,5.37309604 0.373096042,5 0.833333333,5 C1.29357062,5 1.66666667,5.37309604 1.66666667,5.83333333 C1.66666667,6.29357062 1.29357062,6.66666667 0.833333333,6.66666667 Z M2.75,5 L13.0833333,5 C13.2214045,5 13.3333333,5.11192881 13.3333333,5.25 L13.3333333,6.41666667 C13.3333333,6.55473785 13.2214045,6.66666667 13.0833333,6.66666667 L2.75,6.66666667 C2.61192881,6.66666667 2.5,6.55473785 2.5,6.41666667 L2.5,5.25 C2.5,5.11192881 2.61192881,5 2.75,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-portfolio-builder",
    transform: "translate(-971.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header/portfolio-builder/normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header/pf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(60.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "actions",
    transform: "translate(905.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button/secondary/normal-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDBC-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3.333333, 5.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_activity",
    fill: "#8A8888",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#255EBA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.333333, -5.833333)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActivity);
export default __webpack_public_path__ + "static/media/ic_activity.11d7892cb563a322b299ac4e70cae6a4.svg";
export { ForwardRef as ReactComponent };